import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addDashboard,
  getDashboards,
  getDashboard,
  editDashboard,
  deleteDashboard,
  getAllDashboards,
} from "../../store/actions/dashboard_action";

// Get All Data
export const useAllDashboards = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.dashboard);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      const params = new URLSearchParams(window.location.search);

      const paramsObj = Array.from(params.keys()).reduce(
        (acc, val) => ({ ...acc, [val]: params.get(val) }),
        {}
      );
      let newQParams = ``;
      Object.keys(paramsObj) &&
        Object.keys(paramsObj).map((item, index) => {
          if (item.includes("_select")) {
            if (item.split("_select") && item.split("_select")[0]) {
              newQParams += `&select[${item.split("_select")[0]}]=${
                paramsObj[item]
              }`;
            }
          } else {
            newQParams += `&exact[${item}]=${paramsObj[item]}`;
          }
        });
      if (deleteEntry) {
        await dispatch(deleteDashboard(deleteEntry));
      }
      await dispatch(
        getDashboards({
          pageNumber,
          start_from: dateFrom,
          start_to: dateTo,
          queryParams: newQParams,
        })
      );
    }
    allQuery();
  }, [deleteEntry, pageNumber, dateFrom, dateTo, window.location.search]);
  useEffect(() => {
    setPageNumber(1);
  }, [dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [
    data,
    setPageNumber,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
  ];
};

// Get Single Data
export const useSingleDashboard = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.dashboard);
  useEffect(() => {
    dispatch(getDashboard(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateDashboard = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.dashboard);
  const addData = async (data) => {
    await dispatch(addDashboard(data));
  };
  return [data, addData];
};
export const useUpdateDashboard = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.dashboard);
  const updateData = async (id, data) => {
    await dispatch(editDashboard(id, data));
  };
  return [updateData];
};

export const useSelectAllDashboard = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.dashboard);
  useEffect(() => {
    dispatch(getAllDashboards());
  }, [window.location.search]);
  return [data];
};
